import {
  LIST_BOOKINGS_LOADING,
  LIST_PACKAGES_LOADING,
  OPTIMIZE_STOPS,
  CREATE_BOOKING,
  LIST_BOOKINGS,
  LIST_PACKAGES,
  LIST_BY_GROUPS,
  BULK_LOAD_FAILED,
  RELATED_CITIES,
  QUOTE,
  BULK_LOAD,
  LIST_REPORTS,
  BULK_SCHEDULED_FAILED,
  LOADING_PROMO_CODE_REDEEM,
  PROMO_CODE_REDEEM,
  BULK_SCHEDULED_SUCCESS,
  GET_BALANCE,
  QUOTE_SCHEDULE,
  TOTAL_BULK_SCHEDULED,
  SELECT_FREQUENT_ROUTE
} from './constants';
import { flatFormat } from 'utils';
import { PIBOX_CAR_SERVICE_TYPE_ID, SERVICE_TYPE_ID } from 'utils/constants';

const expressReducer = (state, action) => {
  switch (action.type) {
    case CREATE_BOOKING:
      return {
        ...state,
        booking: action.booking
      }
    case QUOTE:
      return {
        ...state,
        quote: action.quote,
        loadingQuote: action.loadingQuote,
        totalWeight: action.quote?.estimated_total_weight && action.quote.estimated_total_weight
      }
    case BULK_LOAD:
      return {
        ...state,
        bulkLoad: action.bulkLoad && action.bulkLoad.stops.map(stop => {
          const info = {
            ...stop,
            packages: [{
              ...stop.packages[0],
              declared_value: flatFormat({ sub_units: stop.packages[0].declared_value.sub_units, iso: stop.packages[0].declared_value.iso }),
              collected_value: stop.packages[0].collected_value ? flatFormat({ sub_units: stop.packages[0].collected_value.sub_units, iso: stop.packages[0].collected_value.iso }) : 0
            }]
          }
          return { ...info }
        }),
        loadingBulkLoad: action.loadingBulkLoad
      }
    case BULK_LOAD_FAILED:
      return {
        ...state,
        totalBulkLoadFailedStops: action.totalBulkLoadFailedStops,
        bulkLoadFailedStops: action.bulkLoadFailedStops && action.bulkLoadFailedStops.map(stop => {
          const info = {
            ...stop,
            packages: stop.packages ? [{
              ...stop.packages[0],
              declared_value: stop.packages[0].declared_value ? flatFormat({ sub_units: stop.packages[0].declared_value.sub_units, iso: stop.packages[0].declared_value.iso }) : null,
              collected_value: stop.packages[0].collected_value ? flatFormat({ sub_units: stop.packages[0].collected_value.sub_units, iso: stop.packages[0].collected_value.iso }) : null
            }] : []
          }
          return { ...info }
        }),
      }
    case OPTIMIZE_STOPS:
      return {
        ...state,
        optimize: action.optimize && action.optimize.booking && action.optimize.booking.stops.map(stop => {
          const info = {
            ...stop,
            packages: [{
              ...stop.packages[0],
              declared_value: flatFormat({ sub_units: stop.packages[0].declared_value.sub_units, iso: stop.packages[0].declared_value.currency }),
              collected_value: stop.packages[0].collected_value ? flatFormat({ sub_units: stop.packages[0].collected_value.sub_units, iso: stop.packages[0].collected_value.currency }) : null
            }]
          }
          return { ...info }
        }),
      }
    case LIST_BOOKINGS:
      return {
        ...state,
        list: action.list
      }
    case LIST_BOOKINGS_LOADING: 
      return {
        ...state,
        loadingBookings: action.loadingBookings
      }
    case LIST_PACKAGES: 
      return {
        ...state,
        listPackages: action.listPackages
      }
    case LIST_PACKAGES_LOADING: 
      return {
        ...state,
        loadingPackages: action.loadingPackages
      }
    case LIST_BY_GROUPS:
      const info = action.listByGroups ? action.listByGroups.length > 0 && action.listByGroups.map(group => {
        return {
          id: group._id,
          title: group.name
        }
      }) : []
      return {
        ...state,
        listByGroups: info?.length > 0 ? [{ id: 'admin', title: 'app.roles.administrative' }].concat(info) : []
      }
    case RELATED_CITIES:
      let cities = action.relatedCities && [action.relatedCities[0]];
      action.relatedCities && action.relatedCities[0]?.related_cities && Object.entries(action.relatedCities[0].related_cities).forEach(([key]) => {
        return cities.push(action.relatedCities[0].related_cities[key])
      })
      return {
        ...state,
        relatedCities: cities.length > 1 ? cities : null
      }
    case LIST_REPORTS:
      return {
        ...state,
        reports: action.reports
      }
    case LOADING_PROMO_CODE_REDEEM: 
      return {
        ...state,
        loadingPromoCode: action.loadingPromoCode
      }
    case PROMO_CODE_REDEEM:
      return {
        ...state,
        promoCode: action.promoCode
      }
    case BULK_SCHEDULED_FAILED:
      return {
        ...state,
        failedScheduled: action.failedScheduled
      }
    case BULK_SCHEDULED_SUCCESS:
      return {
        ...state,
        successScheduled: action.successScheduled
      }
    case TOTAL_BULK_SCHEDULED:
      return {
        ...state,
        totalBulkScheduled: action.totalBulkScheduled
      }
    case GET_BALANCE:
      return {
        ...state,
        balance: action.balance
      }
    case QUOTE_SCHEDULE:
      return {
        ...state,
        quoteSchedule: action.quoteSchedule,
        loadingQuote: action.loadingQuote,
      }
    case SELECT_FREQUENT_ROUTE: {
      if (!action.route) return { ...state, selectedFrequentRoute: null };
      const { route, freightServices, isColombiaMarket } = action;
      const isExpress = route.requested_service_type_id === SERVICE_TYPE_ID;
      const isCar = route.requested_service_type_id === PIBOX_CAR_SERVICE_TYPE_ID;
      const isCargo = !isExpress && !isCar
        && freightServices?.some((f) => f._id === route.requested_service_type_id);
      const carAvailable = !isColombiaMarket || (freightServices?.some((s) => s._id === PIBOX_CAR_SERVICE_TYPE_ID) ?? true);
      const vehicleType = isCargo ? 'cargo' : (isCar && carAvailable) ? PIBOX_CAR_SERVICE_TYPE_ID : 'moto';
      const toFlat = (field) => field ? flatFormat({ sub_units: field.sub_units, iso: field.currency }) : null;
      return {
        ...state,
        selectedFrequentRoute: {
          origin: {
            name: route.address,
            lat: route.origin_geojson.coordinates[1],
            lon: route.origin_geojson.coordinates[0],
            vehicle_types: vehicleType,
            requested_service_type_id: route.requested_service_type_id || null,
          },
          address: route.stops.map((s) => ({ name: s.address, lat: s.lat, lon: s.lon })),
          formValues: {
            secondary_address: route.secondary_address || '',
            return_to_origin: route.return_to_origin || false,
            cost_center_id: route.cost_center_id || '',
            vehicle_types: vehicleType,
            vehicle: isCargo ? route.requested_service_type_id : '',
            requires_parking_fee: route.requires_parking_fee || false,
            requires_service_assistant_fare: route.requires_service_assistant_fare || false,
            use_wallet_balance: route.use_wallet_balance ?? true,
            money_to_pay_for_package: toFlat(route.money_to_pay_for_package) ?? 0,
            requires_a_driver_with_base_money: route.requires_a_driver_with_base_money || false,
            reservations: !!route.hours_dedicated,
            type_services: route.scheduled_at ? 'schedule' : 'express',
            scheduled_at: route.scheduled_at ? new Date(route.scheduled_at) : null,
            hours_dedicated: route.hours_dedicated ?? '',
            stops: route.stops.map((s) => ({
              secondary_address: s.secondary_address || '',
              customer: s.customer || { name: '', country_code: '57', phone: '', email: '' },
              packages: [{
                ...(s.packages?.[0] || {}),
                declared_value: toFlat(s.packages?.[0]?.declared_value) ?? 0,
                collected_value: toFlat(s.packages?.[0]?.collected_value),
                size_cd: s.packages?.[0]?.size_cd ?? 0,
              }],
            })),
          },
        },
      };
    }
    default:
      return state
  }
}

export default expressReducer;
